module.exports = __webpack_public_path__ + "img/gears.e89ead93.svg";